import '../../modules/mode-components';
import dompurify from 'dompurify';
import * as angular from 'angular';

const spaceNameValidationDirective = function ($q) {
  return {
    require: 'ngModel',
    link: function (scope, elm, attrs, ngModel) {
      function validateName(owner, existingSpace, modelValue, viewValue) {
        ngModel.$setValidity('networkError', true);
        const deferred = $q.defer();

        if (ngModel.$isEmpty(modelValue) || (existingSpace && modelValue === existingSpace.name)) {
          // consider empty models to be valid
          ngModel.$setValidity('spaceNameUnavailable', true);
          ngModel.$setValidity('invalidChars', true);
          deferred.resolve();
        }
        if (!ngModel.$isEmpty(modelValue)) {
          const sanitizedValue = dompurify.sanitize(modelValue);
          ngModel.$setValidity('invalidChars', sanitizedValue === modelValue);
          if (sanitizedValue !== modelValue) {
            deferred.reject(new Error('space ' + modelValue + ' is invalid'));
          }
          deferred.resolve();
        }
        if (owner._resource.hasLink('validate_space_name')) {
          owner._resource
            .links('validate_space_name')
            .$follow({ 'space[name]': modelValue })
            .then((response) => {
              if (response.valid) {
                ngModel.$setValidity('spaceNameUnavailable', true);
                deferred.resolve();
              } else {
                ngModel.$setValidity('spaceNameUnavailable', false);
                deferred.reject(new Error('space ' + modelValue + ' is invalid'));
              }
            })
            .catch((response) => {
              ngModel.$setValidity('networkError', false);
              deferred.reject(new Error('Error validating space name'));
            });
        } else {
          // space name validation not available on resource, just return true for now
          // TODO: this case should not exist ideally
          deferred.resolve();
        }
        return deferred.promise;
      }

      ngModel.$asyncValidators.spaceName = validateName.bind(null, scope.ctrl.owner, scope.ctrl.existingSpace);
    },
  };
};

spaceNameValidationDirective.$inject = ['$q'];

angular.module('mode.components').directive('spaceNameValidation', spaceNameValidationDirective);
